import React from 'react'

import {Enum} from './Enum.jsx'
import {Range} from './Range.jsx'
import {Static} from './Static.jsx'
import {Address} from './Address.jsx'

export {Enum, Range, Static, Address}

export const Field = props => {
   let Component,
      classes = []

   if ('address' === props.spec.type) {
      Component = Address
   } else if (props.spec.enum) {
      Component = Enum
   } else if (props.spec.range) {
      Component = Range
   } else {
      Component = Static
   }

   if (props.merged) {
      classes.push('merge')
   }

   if (props.unsafe) {
      classes.push('unsafe')
   }

   return (
      <div className={classes.join(' ')}>
         <Component {...props} />

         {props.merged
            ? <span>The value of this field have been infered, value may not be up to date</span>
            : null}

         {props.unsafe
            ? <span>
                 The update of this field have not been acknowledged, value may not be correct
              </span>
            : null}
      </div>
   )
}

Field.propTypes = {
   spec:   React.PropTypes.object.isRequired,
   field:  React.PropTypes.string.isRequired,
   merged: React.PropTypes.bool,
   unsafe: React.PropTypes.bool
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/fields/index.jsx